<div
  class="gap-[40px] flex flex-col min-h-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[64px] pb-[80px] bg-[#F8F8F8] w-[100%] relative">
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-['archivo'] text-[18px]">{{ loadingLabel }}</span>
  </div>

  <ng-container *ngIf="!isLoading">
    <div
      class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center"
      [@pageTransition]="pageTransitionState">
      <div class="gap-[8px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
        <span
          class="shrink-0 text-[#111215ff] text-center font-normal font-['archivo'] text-[24px] leading-[32px]">
          {{ welcomeBefore }}<strong>{{ staffInfoData?.staffName }}</strong>{{ welcomeAfter }}
        </span>
      </div>

      <div
        class="flex flex-row flex-wrap gap-[16px] w-full shrink-0 justify-center items-center"
        role="tablist"
        [attr.aria-label]="areasLabel">
        <button
          *ngFor="let tab of tabs; trackBy: trackByTabId"
          type="button"
          role="tab"
          class="min-w-[180px] h-[48px] px-[24px] rounded-[8px] font-['archivo'] text-[18px] leading-[24px] border-0 transition-colors duration-200"
          [attr.aria-selected]="activeTab === tab.id"
          [attr.aria-disabled]="tab.disabled"
          [disabled]="tab.disabled"
          [ngClass]="{
            'bg-[#F26F24] text-white cursor-pointer': activeTab === tab.id && !tab.disabled,
            'bg-[#E8E8E8] text-[#111215] cursor-pointer hover:bg-[#DEDEDE]': activeTab !== tab.id && !tab.disabled,
            'bg-[#E8E8E8] text-[#9CA3AF] cursor-not-allowed opacity-70': tab.disabled
          }"
          (click)="selectTab(tab.id, tab.disabled)">
          {{ tab.label }}
        </button>
      </div>

      <div
        class="gap-[28px] flex flex-row flex-wrap w-[100%] shrink-0 justify-center items-center self-stretch"
        role="tabpanel">
        <a
          *ngFor="let card of activeCards; trackBy: trackByCardId"
          class="flex flex-col shrink-0 rounded-[8px] justify-start items-start bg-white border border-[#E5E7EB] w-[360px] overflow-hidden no-underline cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#0f172aff] hover:shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12)] hover:-translate-y-1 transition-all duration-300 ease-out"
          [@cardClick]="clickedCard === card.id ? 'clicked' : ''"
          href="javascript:void(0)"
          (click)="onCardClick(card, $event)"
          [attr.aria-label]="cardOpenLabel(card)">
          <div class="relative w-full h-[240px] overflow-hidden bg-slate-100">
            <div
              *ngIf="!imagesLoaded[card.id]"
              class="absolute inset-0 w-full h-full image-skeleton pointer-events-none"></div>
            <img
              *ngIf="card.image"
              class="w-full h-full object-cover transition-opacity duration-300 pointer-events-none"
              [src]="getImageUrl(card.image)"
              [alt]="cardTitle(card)"
              width="360"
              height="240"
              loading="eager"
              fetchpriority="high"
              decoding="async"
              [class.opacity-0]="!imagesLoaded[card.id]"
              [class.opacity-100]="imagesLoaded[card.id]"
              (load)="onImageLoad(card.id)"
              (error)="onImageError(card.id)" />
          </div>
          <div class="w-full px-[16px] py-[20px] flex items-center justify-center">
            <span
              class="text-[#111215] text-center font-bold font-['archivo'] text-[20px] leading-[24px]">
              {{ cardTitle(card) }}
            </span>
          </div>
        </a>
      </div>
    </div>
  </ng-container>
</div>
